<div id="app-forgot-wrapper" [ngSwitch]="hostname">
  <div *ngSwitchDefault id="app-forgot-wrapper-default">
    <app-index-layout [layoutData]="layoutData">
      <div box-body>
        <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <mat-form-field appearance="fill">
              <mat-label>Email</mat-label>
              <input type="email" matInput formControlName="email" />
              <mat-error *ngIf="!forgotForm.get('email').valid && forgotForm.dirty">
                Please enter a valid email address
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-group buttons text-center">
            <button [disabled]="!forgotForm.valid" class="btn btn-primary">Send</button>
          </div>
        </form>
        <div class="text-center go-back">
          <button routerLink="/" disableRipple mat-button class="delete-user">
            <mat-icon matPreffix>arrow_back_ios</mat-icon>
            Go Back
          </button>
        </div>
      </div>
    </app-index-layout>
  </div>
  <div
    *ngSwitchCase="environment.relutechUrl"
    id="app-forgot-wrapper-relutech"
    class="row d-flex justify-content-center"
  >
    <div class="container-fluid text-center d-flex justify-content-center">
      <div class="row h-100">
        <div id="app-forgot-section-one" class="app-forgot-section col-md">
          <div class="d-flex flex-column justify-content-center h-100">
            <h1 class="text-light">Welcome to the</h1>
            <img class="" src="../../../assets/login/relutech/RAMP%20Logo-01.png" alt="..." />
            <h1 class="text-light">Powered by ReluTech, LLC.</h1>
          </div>
        </div>

        <div id="app-forgot-section-two" class="app-forgot-section col-md">
          <div class="d-flex flex-column justify-content-center align-items-center h-100">
            <div class="form-column">
              <div class="form-header pb-3">
                <h1>Forgot Password</h1>
              </div>
              <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                  <label class="input-label-relutech">Email Address *</label>
                  <input
                    type="text"
                    formControlName="email"
                    class="form-control"
                    autocomplete="email"
                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                  />
                  <div *ngIf="submitted && !!f.email.errors" class="invalid-feedback">
                    <div *ngIf="!!f.email.errors?.required">Email is required</div>
                    <div *ngIf="!!f.email.errors?.email">Email is not valid</div>
                  </div>
                </div>
                <div class="form-group-buttons text-center d-flex justify-content-between align-items-end">
                  <a routerLink="/" class="btn btn-link">< Go Back</a>
                  <button type="submit" class="btn btn-primary btn-relutech">Send</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
